angular.module('rjmNg.directives').directive "dbConnectionEditor", [
  "$url"
  "cloudbiConnectionUtils"
  (
    $url
    cloudbiConnectionUtils
  ) ->
    restrict: "E"
    templateUrl: "connectionEditors/db.html"
    replace: true
    scope: {}
    controller: [
      "$scope"
      "$http"
      "$routeParams"
      "$q"
      "ConnectionMeta"
      "Clients"
      "clientEventService"
      "jobService"
      "app"
      "CONNECTIONS"
      "logger"
      "$clientAppUrl"
      "connectionUtils"
      "cloudbiConnectionUtils"
      "$url"
      "$rootScope"
      (
        $scope
        $http
        $routeParams
        $q
        ConnectionMeta
        Clients
        clientEventService
        jobService
        app
        CONNECTIONS
        logger
        $clientAppUrl
        connectionUtils
        cloudbiConnectionUtils
        $url
        $rootScope
      ) ->

        $scope.connectionsPageUrl = $clientAppUrl('/settings/connection/')
        $scope.baseUrl = $url('')

        $scope.connectionId = null
        $scope.user = app.getUser()
        $scope.client = {}
        $scope.connection =
          meta:
            connection:
              type: null

        $scope.whitelistIps = cloudbiConnectionUtils.AWS_IP_ADDRESS_STR

        connectionTypeFromUrl = if $routeParams.connectionType? then $routeParams.connectionType else null
        $scope.newConnectionTemplate = {id: null, meta: {name: "", connection: {type: connectionTypeFromUrl}, encryption: {type: 'none'}}}

        connectionTypes =
          mongo: 'MongoDB'
          mssql: 'Microsoft SQL'
          mysql: 'MySQL'
          postgres: 'PostgreSQL'
          redshift: 'Redshift (beta)'

        $scope.connectionTypes = angular.copy(connectionTypes)

        checkForAccess = (types) ->
          unless app.clientIsImplemented() then return types

          flags = 
            mysql: 'MYSQL_UI'
            postgres: 'POSTGRES_UI'
            mongo: 'MONGO_UI'
            mssql: 'MSSQL_UI'
            redshift: 'REDSHIFT_UNLOAD'

          for key, value of flags
            unless app.hasFeatureFlag(value)
              delete types[key]

          return types

        $scope.connectionTypes = checkForAccess($scope.connectionTypes)

        $scope.encryptionTypes =
          mysql: {ssh: 'SSH Tunnel', ciscovpn: 'Cisco IPSec VPN', mysqlssl: 'MYSQL SSL'}
          mssql: {ssh: 'SSH Tunnel', ciscovpn: 'Cisco IPSec VPN'}
          mongo: {ssh: 'SSH Tunnel', ciscovpn: 'Cisco IPSec VPN'}
          postgres: {ssh: 'SSH Tunnel', ciscovpn: 'Cisco IPSec VPN'}
          redshift: {ssh: 'SSH Tunnel'}

        $scope.connectionStatus = false
        $scope.showConnectionStatusDetails = false
        $scope.detailsLinkText = "Details"
        $scope.toggleStatusDetails = () ->
          $scope.showConnectionStatusDetails=!$scope.showConnectionStatusDetails
          $scope.detailsLinkText = if $scope.showConnectionStatusDetails then "Hide" else "Details"

        $scope.savingConnection = false
        $scope.notification = ""
        $scope.view =
          encrypted: false
        $scope.showErrors = false
        $scope.connectedData = false
        $scope.portRegex = connectionUtils.REGEX.port
        $scope.alphanumericRegex = connectionUtils.REGEX.alphanumeric
        $scope.hostRegex = connectionUtils.REGEX.host
        $scope.errorMessages = connectionUtils.ERROR_MESSAGES
        $scope.awsRegion = null

        timeoutId = null
        ConnectionMetaInstance = ConnectionMeta(app.getClientId())

        Clients.get(app.getClientId()).then (client) ->
          $scope.client = client

        DEFAULT_PORTS =
          aurora: 3306
          azure: 1433
          cloudsql: 3306
          heroku: 5432
          redshift: 5439
          mariadb: 3306
          mysql: 3306
          mongo: 27017
          postgres: 5432
          mssql: 1433

        AWS_REGIONS =
          US_EAST_1: 'us-east-1'
          US_WEST_1: 'us-west-1'
          US_WEST_2: 'us-west-2'
          EU_WEST_1: 'eu-west-1'
          AP_SOUTHEAST_1: 'ap-southeast-1'
          AP_SOUTHEAST_2: 'ap-southeast-2'
          AP_NORTHEAST_1: 'ap-northeast-1'

        getConnectedData = () ->
          deferred = $q.defer()

          clientEventService.fetch().then( ({data}) ->
            for event in data
              if event.type is 7 # ClientEventType::FIRST_DATA_ADDED
                deferred.resolve(true)

            deferred.resolve(false)
          )

          return deferred.promise

        showNotFoundErrorMessage = (error) ->
          if status is 404
            $scope.notification = "Connection deleted or not found. Please click 'Back to Connections' to return to the connections page."

        startStatusChecker = () ->
          if !$scope.connectedData
            getConnectedData().then( (result) ->
              $scope.connectedData = result
            )

          ConnectionMetaInstance.status($scope.connectionId, true, false).then((result) ->
            $scope.connectionStatus = result
            $rootScope.$broadcast('updateConnectionStatus')
            if result.status is "Testing..."
              timeoutId = setTimeout(startStatusChecker, 10000)
            else if result.status is "FAIL"
              $scope.toggleStatusDetails()
          , showNotFoundErrorMessage)

        stopStatusChecker = () ->
          if (angular.isDefined(timeoutId))
            clearTimeout(timeoutId)
            timeoutId = null

        queueConnectionTest = () ->
          connectionTestJob = 27 # JobType::CONNECTION_TEST
          jobService(connectionTestJob).queue(
            connectionId : $scope.connectionId
            syncAndSample: 1
          )

        if $routeParams.connectionId?
          $scope.connectionId = $routeParams.connectionId

        if $scope.connectionId is null
          $scope.connection = $scope.newConnectionTemplate
          $scope.view.encrypted = false
        else
          ConnectionMetaInstance.connection($scope.connectionId).then(({data}) ->
            $scope.connection = data
            $scope.view.encrypted = ($scope.connection.meta.encryption.type isnt 'none')
            if $scope.connection.meta.connection.type not in Object.keys($scope.connectionTypes)
              $scope.connectionTypes[$scope.connection.meta.connection.type] = connectionTypes[$scope.connection.meta.connection.type]
          ).catch(showNotFoundErrorMessage)

          startStatusChecker()
          getConnectedData().then( (result) ->
            $scope.connectedData = result
          )

        $scope.$watch('view.encrypted', (newValue, oldValue) ->
          if oldValue is false and newValue is true and $scope.connection.meta.encryption.type is 'none'
            $scope.connection.meta.encryption.type = 'ssh'
        )

        $scope.$watch('connection.meta.connection.type', (newValue, oldValue) ->
          if $scope.view.encrypted and not $scope.encryptionTypes[newValue][$scope.connection.meta.encryption.type]?
            $scope.connection.meta.encryption.type = 'ssh'
          setDefaultPort()
        )

        $scope.$on('$destroy', () ->
          stopStatusChecker()
        )

        $scope.awsRegions = (region for key, region of AWS_REGIONS)

        $scope.saveConnection = () ->
          $scope.savingConnection = true
          $scope.showConnectionStatusDetails = false
          if(validateConnection())
            if not $scope.view.encrypted
              $scope.connection.meta.encryption = {type: 'none'}

            ConnectionMetaInstance.save($scope.connection).then(({data}) ->
              $scope.savingConnection = false
              $scope.notification = "The connection was successfully saved and a connection test has been queued."
              if $scope.connectionId is null
                $scope.connectionId = $scope.connection.id = data.connectionId
                logger.log(
                  $scope.connection.meta.connection.type + " connection",
                  'Save',
                  $scope.connectionId,
                  'create'
                )
              else
                logger.log(
                  $scope.connection.meta.connection.type + " connection",
                  'Save',
                  $scope.connectionId,
                  'edit'
                )

              queueConnectionTest()
              stopStatusChecker()
              startStatusChecker()
            ).catch(({data}) ->
              $scope.savingConnection = false
              $scope.connectionStatus = data
            )
          else
            $scope.savingConnection = false
            $scope.showErrors = true

        $scope.showDbName = () ->
          cloudbiConnectionUtils.showDbName($scope.connection.meta.connection.type)

        $scope.dbNameOptional = () ->
          cloudbiConnectionUtils.isDbNameOptional($scope.connection.meta.connection.type)

        $scope.dbNameRequired = () ->
          cloudbiConnectionUtils.isDbNameRequired($scope.connection.meta.connection.type)

        $scope.isAlwaysEncrypted = () ->
          cloudbiConnectionUtils.isAlwaysEncrypted($scope.connection.meta.connection.type)

        $scope.showAwsRegion = () ->
          $scope.connection.meta.connection.type is CONNECTIONS.TYPES.REDSHIFT

        $scope.openSupport = () ->
          zE(() ->
            zE.activate(
              hideOnClose: true
            )
          )

        setDefaultPort = () ->
          if $scope.connection.meta?
            defaultPorts = DEFAULT_PORTS
            type = $scope.connection.meta.connection.type
            defaultPort = null
            if type in Object.keys(defaultPorts)
              defaultPort = defaultPorts[type]
            $scope.connection.meta.connection.port ?= defaultPort

        setDefaultPort()

        validateConnection = () ->
          if $scope.connectionForm.$valid and (!$scope.view.encrypted or ($scope.view.encrypted and $scope[$scope.connection.meta.encryption.type+'EncryptionForm'].$valid))
            return true
          else if $scope.isAlwaysEncrypted()
            return true
          else
            return false

    ]
    link: (scope) ->

      scope.$watchGroup [
        "connection.meta.connection.host"
        "connection.meta.connection.type"
      ], () ->
        scope.awsRegion = cloudbiConnectionUtils.getAwsRegion(scope.connection?.meta?.connection?.host)
        if scope.showAwsRegion() and
          not scope.connection?.meta?.connection?.region? and
          scope.awsRegion in scope.awsRegions
            scope.connection.meta.connection.region = scope.awsRegion

]
